import { useAuth } from '@/context/AuthContext';
import StaffPermissionsCard from '@/components/StaffPermissionsCard';

// Phase 1 — Staff Management. Dedicated page for the per-staff permission
// matrix (previously only available inside the global Settings page).
export default function StaffPermissionsPage() {
  const { user } = useAuth();
  if (user?.role !== 'admin') {
    return (
      <div className="p-8 text-center">
        <p className="text-sm text-[#EF4444]">Admin access required</p>
      </div>
    );
  }
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-5" data-testid="staff-permissions-page">
      <p className="text-xs text-[#52525B]">
        Toggle View / Edit / Delete rights per staff member, per module. Admins always have full access.
      </p>
      <StaffPermissionsCard />
    </div>
  );
}
